import { render, staticRenderFns } from "./model-params.vue?vue&type=template&id=0e9e118e&scoped=true&"
import script from "./model-params.vue?vue&type=script&lang=ts&"
export * from "./model-params.vue?vue&type=script&lang=ts&"
import style0 from "./model-params.vue?vue&type=style&index=0&id=0e9e118e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9e118e",
  null
  
)

export default component.exports